import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Gallery.css';

const galleryWorks = [
  {
    title: 'Hampton By Hilton Shooting',
    image: '/images/hotelshooting-8.jpg',
    button: 'VIEW ALBUM',
    album: [
      
      '/images/hotelshooting-2.jpg',
      '/images/hotelshooting-3.jpg',
      '/images/hotelshooting-4.jpg',
      '/images/hotelshooting-5.jpg',
      '/images/hotelshooting-6.jpg',
      '/images/hotelshooting-7.jpg',
      '/images/hotelshooting-9.jpg',
      '/images/hotelshooting-10.jpg',
      '/images/hotelshooting-11.jpg',
      '/images/hotelshooting-12.jpg',
      '/images/hotelshooting-13.jpg',
      '/images/hotelshooting-14.jpg',
      '/images/hotelshooting-15.jpg',
      '/images/hotelshooting-16.jpg'
    ]
  },
  {
    title: 'G & A Wedding',
    image: '/images/GAwedding/GAwedding-8.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/GAwedding/GAwedding-2.jpg',
      '/images/GAwedding/GAwedding-3.jpg',
      '/images/GAwedding/GAwedding-4.jpg',
      '/images/GAwedding/GAwedding-5.jpg',
      '/images/GAwedding/GAwedding-6.jpg',
      '/images/GAwedding/GAwedding-7.jpg',
      '/images/GAwedding/GAwedding-9.jpg',
      '/images/GAwedding/GAwedding-10.jpg',
      '/images/GAwedding/GAwedding-11.jpg',
      '/images/GAwedding/GAwedding-12.jpg',
      '/images/GAwedding/GAwedding-13.jpg',
      '/images/GAwedding/GAwedding-14.jpg',
      '/images/GAwedding/GAwedding-15.jpg'
    ]
  },
  {
    title: 'D & D Wedding',
    image: '/images/DDwedding/DDwedding-11.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/DDwedding/DDwedding.jpg',
      '/images/DDwedding/DDwedding-2.jpg',
      '/images/DDwedding/DDwedding-3.jpg',
      '/images/DDwedding/DDwedding-4.jpg',
      '/images/DDwedding/DDwedding-5.jpg',
      '/images/DDwedding/DDwedding-6.jpg',
      '/images/DDwedding/DDwedding-7.jpg',
      '/images/DDwedding/DDwedding-8.jpg',
      '/images/DDwedding/DDwedding-9.jpg',
      '/images/DDwedding/DDwedding-10.jpg',
      '/images/DDwedding/DDwedding-11.jpg'
    ]
  },
  {
    title: 'Christening',
    image: '/images/Dbotez/Christening-2.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/Dbotez/Christening-2.jpg',
      '/images/Dbotez/Christening-3.jpg',
      '/images/Dbotez/Christening.jpg',
      '/images/Dbotez/Christening-7.jpg',
      '/images/Dbotez/Christening-9.jpg',
      '/images/Dbotez/Christening-11.jpg',
      '/images/Dbotez/Christening-15.jpg',
      '/images/Dbotez/Christening-4.jpg',
      '/images/Dbotez/Christening-5.jpg',
      '/images/Dbotez/Christening-6.jpg',
      '/images/Dbotez/Christening-8.jpg',
      '/images/Dbotez/Christening-10.jpg',
      '/images/Dbotez/Christening-12.jpg',
      '/images/Dbotez/Christening-13.jpg',
      '/images/Dbotez/Christening-16.jpg',
      '/images/Dbotez/Christening-17.jpg',
      '/images/Dbotez/Christening-18.jpg',
      '/images/Dbotez/Christening-14.jpg'
    ]
  },
  {
    title: 'Nail Salon',
    image: '/images/nails/nails.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/nails/nails-2.jpg',
      '/images/nails/nails-3.jpg',
      '/images/nails/nails-4.jpg',
      '/images/nails/nails-5.jpg'
      
    ]
  },
  {
    title: 'B2B Car Sale',
    image: '/images/cars/car.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/cars/car-2.jpg',
      '/images/cars/car-3.jpg',
      '/images/cars/car-4.jpg',
      '/images/cars/car-5.jpg'
    ]
  },
  {
    title: 'Newborn Photoshoot',
    image: '/images/newborn/newborn.jpg',
    button: 'VIEW ALBUM',
    album: [
      '/images/newborn/newborn-2.jpg',
      '/images/newborn/newborn-3.jpg',
      '/images/newborn/newborn-4.jpg',
      '/images/newborn/newborn-5.jpg',
      '/images/newborn/newborn-6.jpg'
    ]
  }
];

function Gallery() {
  const [isAlbumOpen, setIsAlbumOpen] = useState(false);
  const [albumIndex, setAlbumIndex] = useState(0);
  const [currentAlbum, setCurrentAlbum] = useState([]);

  const openAlbum = (idx = 0) => {
    setCurrentAlbum(galleryWorks[idx].album);
    setAlbumIndex(0);
    setIsAlbumOpen(true);
  };

  const closeAlbum = () => setIsAlbumOpen(false);
  const nextAlbum = () => setAlbumIndex((prev) => (prev + 1) % currentAlbum.length);
  const prevAlbum = () => setAlbumIndex((prev) => (prev - 1 + currentAlbum.length) % currentAlbum.length);

  useEffect(() => {
    if (!isAlbumOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeAlbum();
      if (e.key === 'ArrowRight') nextAlbum();
      if (e.key === 'ArrowLeft') prevAlbum();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isAlbumOpen, currentAlbum, albumIndex]);

  return (
    <div className="gallery-section">
      <Helmet>
        <title>Photography Portfolio | Wedding, Newborn & Commercial Gallery</title>
        <meta name="description" content="Explore our photography portfolio featuring wedding photography, newborn portraits, and commercial work. View our latest projects and photography style." />
        <meta name="keywords" content="photography portfolio, wedding gallery, newborn photos, commercial photography, Bristol photographer portfolio" />
        <meta property="og:title" content="Photography Portfolio | Wedding, Newborn & Commercial Gallery" />
        <meta property="og:description" content="Explore our photography portfolio featuring wedding photography, newborn portraits, and commercial work." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/gallery" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/gallery" />
      </Helmet>
      <h1>Gallery</h1>
      <p>Browse our portfolio of beautiful moments and events.</p>
      <div className="latest-work-slider-container">
        <div className="latest-work-slider">
          {galleryWorks.map((work, idx) => (
            <div className="latest-work-card" key={idx}>
              <img src={work.image} alt={work.title} className="latest-work-card-img" />
              <div className="latest-work-card-title">{work.title}</div>
              <button className="view-album-btn" onClick={() => openAlbum(idx)}>{work.button}</button>
            </div>
          ))}
        </div>
      </div>
      {/* Album Modal */}
      {isAlbumOpen && (
        <div className="album-modal-overlay" onClick={closeAlbum}>
          <div className="album-modal" onClick={e => e.stopPropagation()}>
            <button className="album-close-btn" onClick={closeAlbum}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={prevAlbum}>&#8592;</button>
            <img className="album-image" src={currentAlbum[albumIndex]} alt={`Album ${albumIndex + 1}`} />
            <button className="album-arrow album-arrow-right" onClick={nextAlbum}>&#8594;</button>
            <div className="album-indicators">
              {currentAlbum.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === albumIndex ? 'album-dot active' : 'album-dot'}
                  onClick={() => setAlbumIndex(idx)}
                  aria-label={`Go to album image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery; 